import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Avatar,
  Grid,
  Divider,
} from "@mui/material";
import { Email, Phone } from "@mui/icons-material";

const Profile = () => {
  // Read from localStorage
  const name = localStorage.getItem("name") || "User";
  const email = localStorage.getItem("email") || "user@example.com";
  const role = localStorage.getItem("role") || "User";
  const joinedDate = localStorage.getItem("joinedDate") || new Date().toLocaleDateString();
  const phone = localStorage.getItem("phone") || "+91 0000000000";
  const avatar = "/profile.png";

  return (
    <Box
      sx={{

        maxWidth: '100%',
        mx: "auto",
        mt: 2,
        width: "100%",
      }}
    >
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: 4,
          p: 2,

        }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Avatar
                src={avatar}
                alt={name}
                sx={{
                  width: 100,
                  height: 100,
                  fontSize: 40,
                  bgcolor: "#7C0BCC",
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={8}>
            <CardContent>
              <Typography variant="h5" fontWeight="bold" gutterBottom>
                {name}
              </Typography>

              <Box display="flex" alignItems="center" mb={1}>
                <Email sx={{ mr: 1, color: "text.secondary" }} />
                <Typography variant="body1">{email}</Typography>
              </Box>

              <Box display="flex" alignItems="center">
                <Phone sx={{ mr: 1, color: "text.secondary" }} />
                <Typography variant="body1">{phone}</Typography>
              </Box>
            </CardContent>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        <Grid container spacing={2}>
          <Grid item xs={6} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Role
            </Typography>
            <Typography variant="body1">{role}</Typography>
          </Grid>

          <Grid item xs={6} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Joined On
            </Typography>
            <Typography variant="body1">{joinedDate}</Typography>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
};

export default Profile;
